// @flow
import React from 'react';
import { GoogleIcon } from './GoogleIcon';
import { GoogleSourceLink } from './partials';

const GOOGLE_SOURCE_URL = 'https://www.google.com/preferences/source?q=finect.com';

/**
 * Botón para que el usuario marque Finect como fuente preferida en Google
 * (con finect.com preseleccionado). Se muestra en la cabecera de los artículos
 * de finecters / del grupo Finect, junto a la barra de interacción.
 */
export const GoogleSourceButton = () => (
  <GoogleSourceLink
    href={GOOGLE_SOURCE_URL}
    target="_blank"
    rel="noopener noreferrer"
    title="Añade Finect como fuente preferida en Google"
    data-fi-event="article-googleSource"
  >
    <GoogleIcon />
    Añade Finect en Google
  </GoogleSourceLink>
);
